export default __webpack_public_path__ + "static/card-3-df145d0295cd536ee5087d35bd921d10.png";